<template>
  <el-container>
    <el-main style="padding: 0">
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="skills"
          @select="select"
          @select-all="select">
        <div slot="toolbar">
          <el-button v-if="addAuth" type="primary" @click="$refs.editPage.open(0)"> 新建 </el-button>
          <el-button v-if="delAllAuth" :disabled="!selection.length" type="danger" @click="deleteRows"> 批量删除 </el-button>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="技能编号：">
              <el-input v-model.trim="filter.skillNo" placeholder="请输入技能编号" clearable/>
            </vm-search>
            <vm-search label="技能名称：">
              <el-input v-model.trim="filter.skillName" placeholder="请输入技能名称" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column type="selection" align="center" width="55" prop="selection"/>
        <el-table-column prop="skillNo" align="center" label="技能编号" width="120"/>
        <el-table-column prop="skillName" align="left" label="技能名称"/>
        <el-table-column prop="creatorName" align="center" width="120" label="创建人"/>
        <el-table-column prop="createTime" align="center" width="150" label="创建时间"/>
        <el-table-column
            label="操作"
            align="center"
            fixed="right"
            prop="action"
            width="120">
          <template slot-scope="scope">
            <el-button v-if="editAuth" type="primary" @click="$refs.editPage.open(scope.row.pkid)"> 编辑 </el-button>
            <el-button v-if="delAuth" type="danger" @click="deleteRow(scope.row.pkid)"> 删除 </el-button>
          </template>
        </el-table-column>
      </vm-table>
      <skill-edit ref="editPage" @save-success="getList(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import SkillEdit from "./SkillEdit";
  export default {
    name: "SkillList",
    components: { SkillEdit, VmTable, VmSearch },
    data() {
      return {
        addAuth: this.$auth(187),
        delAllAuth: this.$auth(188),
        editAuth: this.$auth(189),
        delAuth: this.$auth(190),
        selection: [],
        filter: {},
      };
    },

    mounted() {
      this.getList(1);
    },

    methods: {
      // 查询
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      select(selection) {
        this.selection = selection;
      },

      // 单个删除
      deleteRow(pkid) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "skills", pkid).then((resp) => {
            if (resp.success) {
              this.getList(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      // 批量删除
      deleteRows() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "skills/batchDelete", ids).then((resp) => {
            if (resp.success) {
              this.getList(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },
    },
  };
</script>
